import type { WriteRejection } from "@estelle/domain";

/**
 * One line describing why a write was refused.
 *
 * `docs.savePage`, `restoreRevision`, `setGrant` and `removeGrant` take no
 * `Guarded`, so `conflict` cannot occur from anything this module calls
 * today — but the union carries no way to say that, and the switch has no
 * `default`: a sixth rejection kind added to `@estelle/domain` fails this
 * file at compile time instead of silently describing it as nothing.
 * `forbidden` is the one that actually fires — a save from someone holding
 * only Read on the folder.
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "conflict":
      return `${rejection.message} It changed at ${rejection.currentUpdatedAt}.`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "blocked":
    case "channel_rejected":
      return rejection.message;
  }
}
